var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoVoucher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 396,
    height: 336,
    viewBox: "0 0 396 336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,336.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 3341 c-16 -10 -39 -28 -50 -41 -19 -21 -20 -38 -23 -483 -2 -365 0 -462 10 -469 7 -4 32 -8 54 -8 62 0 190 -40 269 -84 104 -58 212 -171 264 -277 56 -115 75 -193 75 -314 -1 -159 -45 -289 -143 -416 -50 -65 -154 -151 -226 -187 -61 -30 -168 -61 -240 -68 l-65 -7 0 -436 c0 -488 0 -485 71 -523 32 -17 112 -18 1909 -18 1797 0 1877 1 1909 18 19 10 43 34 53 53 17 32 18 102 18 1602 0 1703 4 1592 -55 1647 l-27 25 -1886 3 c-1824 2 -1888 1 -1917 -17z m3765 -1656 l0 -1555 -1860 0 -1860 0 0 374 0 374 51 11 c145 31 276 106 394 225 135 136 202 275 226 468 42 345 -166 691 -496 825 -44 18 -101 36 -127 39 l-48 7 0 393 0 394 1860 0 1860 0 0 -1555z",
    fill: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2052 2320 c-187 -50 -338 -173 -422 -342 -94 -191 -93 -395 1 -588 34 -69 58 -101 128 -170 143 -141 288 -197 488 -187 180 8 310 64 433 187 145 146 209 328 188 538 -14 148 -79 283 -189 392 -128 127 -257 181 -439 187 -91 2 -130 -1 -188 -17z m192 -316 c13 -13 16 -46 16 -203 0 -200 -3 -211 -50 -211 -47 0 -50 11 -50 211 0 199 5 219 50 219 10 0 26 -7 34 -16z m6 -583 c23 -45 1 -91 -45 -91 -13 0 -31 7 -39 16 -36 36 -9 94 44 94 19 0 33 -7 40 -19z",
    fill: "#a02c8d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoVoucher);
export default __webpack_public_path__ + "static/media/info-voucher.e85e5dca0707a9caa1e6d6c28cc3f764.svg";
export { ForwardRef as ReactComponent };